import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'found';
import {
  Accordion,
  Button,
  Container,
  Grid,
  Icon,
  Item,
  Segment
} from 'semantic-ui-react';
import MobileHeader from '../App/MobileHeader';
import {
  Analytics,
  AvailabilityChecker,
  GlobalNotifications,
  Intent
} from '../Modules';
import withAuth from '../App/Authenticate';
import { FloatingLabelInput as Input } from '../Elements';
import Formsy from 'formsy-react';
import styles from './Leads.scss';
import SMSNotifications from './SMSNotifications';
import ClipboardButton from 'react-clipboard.js';
import RecaptchaSettings from './RecaptchaSettings';

const LinkComponent = class LeadLink extends React.Component {
  static propTypes = {
    toggleSidebar: PropTypes.func,
    sidebarOpen: PropTypes.bool,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.textFieldChange = this.textFieldChange.bind(this);
    this.getLink = this.getLink.bind(this);
    this.onAccordionClick = this.onAccordionClick.bind(this);
    this.onSuccessfulCopy = this.onSuccessfulCopy.bind(this);
    this.state = {
      title: 'Contact Us',
      redirectURI: '',
      activeIndex: 0
    };
  }

  componentDidMount() {
    Analytics.trackEvent('viewed-lead-link');
  }

  onAccordionClick(e, titleProps) {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  }

  onSuccessfulCopy() {
    GlobalNotifications.show({
      message: 'Successfully copied link',
      intent: Intent.SUCCESS
    });
  }

  getLink() {
    return `${process.env.BASE_URL}/embed_widgets/${this.props.viewer
      .embed_token}?${this.state.title !== ''
      ? `&title=${encodeURIComponent(this.state.title)}`
      : ''}${this.state.redirectURI !== ''
      ? `&redirect_uri=${encodeURIComponent(this.state.redirectURI)}`
      : ''}`;
  }

  textFieldChange(e) {
    const newValue = {};
    newValue[e.target.name] = e.target.value;
    this.setState(Object.assign(this.state, newValue));
  }

  render() {
    const link = this.getLink();
    const { relay, router, sidebarOpen, toggleSidebar, viewer } = this.props;
    const { activeIndex } = this.state;
    return (
      <Container>
        <Segment style={{ marginTop: '2em' }}>
          <MobileHeader viewer={viewer} router={router}>
            <div className='menu'>
              <Item
                as='a'
                className={sidebarOpen ? 'active ' : ''}
                onClick={toggleSidebar}
              >
                <Icon name='sidebar' />
              </Item>
            </div>
            <div className='right menu'>
              <AvailabilityChecker viewer={viewer} mobile />
              <Item as='a' onClick={router.push.bind(null, '/search')}>
                <Icon name='search' />
              </Item>
            </div>
          </MobileHeader>
          <Grid padded stackable>
            <Grid.Row columns='equal'>
              <Grid.Column>
                <h1>Contact Link</h1>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={16}>
                <p>
                  This is one of the fastest and easiest ways to integrate your
                  website with Cloverbook. Just create a link on your website
                  that points to the URL below. When a user clicks on the link,
                  they are taken to your personal Cloverbook contact form. Once
                  they submit the form, they can be redirected back to the URL
                  of your choice.
                </p>
                <br />
                <Formsy.Form>
                  <Input
                    name='link'
                    value={link}
                    label='Contact Link'
                    type='text'
                    fluid
                    onChange={() => {}}
                    onFocus={e => {
                      e.target.select();
                    }}
                  />
                </Formsy.Form>
                <br />
                <p>
                  <ClipboardButton
                    option-text={this.getLink}
                    onSuccess={this.onSuccessfulCopy}
                    className='ui right icon button primary button'
                  >
                    <span>
                      Copy Link&nbsp;<Icon name='copy outline' />
                    </span>
                  </ClipboardButton>
                  <a href={link}>
                    <Button basic content='Test Link' />
                  </a>
                </p>
                <br />
                <Accordion styled fluid>
                  <Accordion.Title
                    index={0}
                    active={activeIndex === 0}
                    onClick={this.onAccordionClick}
                  >
                    <Icon name='dropdown' />
                    Settings
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 0}>
                    <Grid padded relaxed stackable>
                      <Grid.Row>
                        <Grid.Column
                          width={5}
                          className={styles.settingsLabels}
                        >
                          <p>
                            <strong>Title</strong>
                          </p>
                          <p className={styles.helperText}>
                            <em>Customize the title of your form</em>
                          </p>
                        </Grid.Column>
                        <Grid.Column width={11}>
                          <Formsy.Form className='ui form'>
                            <Input
                              label='Title'
                              type='text'
                              name='title'
                              value={this.state.title}
                              onChange={this.textFieldChange}
                            />
                          </Formsy.Form>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column
                          width={5}
                          className={styles.settingsLabels}
                        >
                          <p>
                            <strong>Redirect URL</strong>
                          </p>
                          <p className={styles.helperText}>
                            <em>
                              When users submit your form, we will automatically
                              redirect them to the URL provided
                            </em>
                          </p>
                        </Grid.Column>
                        <Grid.Column width={11}>
                          <Formsy.Form className='ui form'>
                            <Input
                              label='Redirect URL'
                              type='text'
                              name='redirectURI'
                              value={this.state.redirectURI}
                              onChange={this.textFieldChange}
                              validations='isUrl'
                              validationError='Must be a valid URL (Ex. http://www.example.com)'
                            />
                          </Formsy.Form>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column
                          width={5}
                          className={styles.settingsLabels}
                        >
                          <p>
                            <strong>SMS Notifications</strong>
                          </p>
                          <p className={styles.helperText}>
                            <em>
                              Receive an SMS text message immediately after a
                              user submits an inquiry through your form.
                            </em>
                          </p>
                        </Grid.Column>
                        <Grid.Column width={11}>
                          <SMSNotifications viewer={viewer} relay={relay} />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Accordion.Content>
                  <Accordion.Title
                    index={1}
                    active={activeIndex === 1}
                    onClick={this.onAccordionClick}
                  >
                    <Icon name='dropdown' />
                    reCAPTCHA Spam Protection
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 1}>
                    <RecaptchaSettings viewer={viewer} relay={relay} />
                  </Accordion.Content>
                </Accordion>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Container>
    );
  }
};

export default withRouter(withAuth(LinkComponent));



// WEBPACK FOOTER //
// ./webpack/components/Leads/LinkComponent.js